import store from "../../store/store";

export const componentKey = "ORDER_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setOrderListData: (state, action) => {
      state.orderListData = action.payload;
    },
    setCloseOrderDialog: (state, action) => {
      state.closeOrderDialog = action.payload;
    },
  },
  initialReducerState: {
    orderListData: {},
    closeOrderDialog: false,
  },
});

export const { setOrderListData, setCloseOrderDialog } = actions;
